import React from 'react'
import PropTypes from 'prop-types'
import VillageOpenHours from 'components/OpenHours/VillageOpenHours'
import { Block, Spacing50 } from 'styles/sharedStyle'
import { withTheme } from 'styled-components'

const Layout = ({ data, children, pageContext, theme }) => {
  const { page, openingHoursLabels, openingHoursExceptions } = data || {}
  const village = page && page.village
  const pageLevel = pageContext ? pageContext.pageLevel : ''
  const showHours =
    village &&
    village.openingHours &&
    pageLevel === 'village' &&
    openingHoursLabels &&
    openingHoursExceptions

  return (
    <main style={{ backgroundColor: theme.colors.backgroundColor }}>
      {children}
      {showHours && (
        <Block>
          <Spacing50 />
          <VillageOpenHours
            background="Grey"
            openingHoursExceptions={openingHoursExceptions}
            openingHoursLabels={openingHoursLabels}
            village={village}
          />
        </Block>
      )}
    </main>
  )
}

export default withTheme(Layout)

Layout.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
  pageContext: PropTypes.oneOfType([PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  theme: PropTypes.oneOfType([PropTypes.object]),
}

Layout.defaultProps = {
  data: null,
  pageContext: null,
  children: null,
  theme: null,
}
